import React from "react";
import { Box, Typography, Link, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  flevtintend: {
    paddingLeft: theme.spacing(3),
  },
  secondol: {
    paddingLeft: theme.spacing(4),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.4em",
    },
  },
}));
const InformationClause = ({ globalData }) => {
  const classes = useStyles();

  return (
    <Box alignItems="center" display="block">
      <Typography paragraph variant="h3">
        Informacja Administratora – zgodnie z art. 13 ust. 1 i 2 oraz art. 14
        ust 1 i 2 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z
        dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z
        przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich
        danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
        ochronie danych, RODO)
      </Typography>
      <Typography component="p" display="block" paragraph>
        Informuję, że:
      </Typography>
      <ol className={classes.secondol}>
        <Typography point-attr="1." component="li">
          Administratorem Pani/Pana danych osobowych jest Województwo Podlaskie
          reprezentowane przez Marszałka oraz Zarząd Województwa Podlaskiego z
          siedzibą przy ul. Kardynała Stefana Wyszyńskiego 1. 15-888 Białystok,
          tel. +48 (85) 66 54 549, e-mail: 
          <Link href="mailto:kancelaria@podlaskie.eu">
            kancelaria@podlaskie.eu
          </Link>
          , 
          <Link target="_blank" href="https://bip.podlaskie.eu/">
            https://bip.podlaskie.eu/
          </Link>
          )
        </Typography>
        <Typography point-attr="2." component="li">
          Administrator wyznaczył pana Roberta Kursę do pełnienia funkcji
          Inspektora Ochrony Danych (IOD), z którym może Pani/Pan kontaktować
          się listownie wysyłając pismo na ww. adres lub pod adresem poczty
          elektronicznej:{" "}<Link href="mailto:iod@podlaskie.eu">iod@podlaskie.eu</Link>
           lub poprzez 
          <Link
            target="_blank"
            href="https://epuap.gov.pl/wps/portal/strefa-klienta/katalog-spraw/sprawy-ogolne/ogolne-sprawy-urzedowe-2/pismo-ogolne-do-podmiotu-publicznego-nowe"
          >
            Elektroniczną Skrzynkę Podawczą
          </Link>
          .
        </Typography>
        <Typography point-attr="3." component="li">
          Pani/Pana dane osobowe (nazwiska i imiona, miejsce pracy, numer
          telefonu, adres e-mail, login do portalu KM{" "}
          {getSystemLabel("programShortcut", globalData.systemInfo)}) są
          przetwarzane w celach związanych z funkcjonowaniem Komitetu
          Monitorującego {getSystemLabel("programYears", globalData.systemInfo)}
          , tj.: realizacji zadań Sekretariatu Komitetu związanych z obsługą
          Komitetu, realizacją obowiązków informacyjnych i promocyjnych, na
          potrzeby badań ewaluacyjnych, zarządzania, sprawozdawczości i
          raportowania w ramach Programu. Podstawą prawną przetwarzania danych
          osobowych jest obowiązek prawny ciążący na administratorze (art. 6
          ust. 1 lit. c) RODO) określony w:
        </Typography>
        {globalData.systemInfo.fundProgram === "fedp2127" ? (
          <ol className={classes.secondol}>
            <Typography point-attr="1." component="li">
              Rozporządzeniu Parlamentu Europejskiego i Rady (UE) 2021/1060 z
              dnia 24 czerwca 2021 r. ustanawiającego wspólne przepisy dotyczące
              Europejskiego Funduszu Rozwoju Regionalnego, Europejskiego
              Funduszu Społecznego Plus, Funduszu Spójności, Funduszu na rzecz
              Sprawiedliwej Transformacji i Europejskiego Funduszu Morskiego,
              Rybackiego i Akwakultury, a także przepisy finansowe na potrzeby
              tych funduszy oraz na potrzeby Funduszu Azylu, Migracji i
              Integracji, Funduszu Bezpieczeństwa Wewnętrznego i Instrumentu
              Wsparcia Finansowego na rzecz Zarządzania Granicami i Polityki
              Wizowej
            </Typography>
            <Typography point-attr="2." component="li">
              Ustawie z dnia 28 kwietnia 2022 r. o zasadach realizacji zadań
              finansowanych ze środków europejskich w perspektywie finansowej
              2021-2027.
            </Typography>
          </ol>
        ) : (
          <ol className={classes.secondol}>
            <Typography point-attr="a." component="li">
              Rozporządzeniu Parlamentu Europejskiego i Rady (UE) Nr 1303/2013 z
              dnia 17 grudnia 2013 r. ustanawiającym wspólne przepisy dotyczące
              Europejskiego Funduszu Rozwoju Regionalnego, Europejskiego
              Funduszu Społecznego, Funduszu Spójności, Europejskiego Funduszu
              Rolnego na rzecz Rozwoju Obszarów Wiejskich oraz Europejskiego
              Funduszu Morskiego i Rybackiego oraz ustanawiającym przepisy
              ogólne dotyczące Europejskiego Funduszu Rozwoju Regionalnego,
              Europejskiego Funduszu Społecznego, Funduszu Spójności i
              Europejskiego Funduszu Morskiego i Rybackiego oraz uchylającym
              rozporządzenie Rady (WE) nr 1083/2006.
            </Typography>
            <Typography point-attr="b." component="li">
              Ustawie z dnia 11 lipca 2014 r. o zasadach realizacji programów w
              zakresie polityki spójności finansowanych w perspektywie
              finansowej 2014-2020.
            </Typography>
          </ol>
        )}
        {globalData.systemInfo.fundProgram === "fedp2127" ? (
          <>
            <Typography point-attr="4." component="li">
              Podanie danych osobowych jest wymogiem ustawowym pozwalającym na
              realizację ww. celów, konsekwencją niepodania danych będzie brak
              możliwości udziału w pracach Komitetu Monitorującego program
              Fundusze Europejskie dla Podlaskiego 2021-2027.
            </Typography>
            <Typography point-attr="5." component="li">
              Pani/Pana dane osobowe będą ujawniane, z zachowaniem odpowiednich
              standardów bezpieczeństwa, osobom ze składu Komitetu zgodnie z
              postanowieniami określonymi w Regulaminie Komitetu, osobom
              upoważnionym przez Administratora, podmiotom prowadzącym
              działalność bankową, operatorowi pocztowemu lub kurierowi oraz
              podmiotom realizującym archiwizację, obsługę informatyczną i
              teleinformatyczną, a także innym podmiotom/osobom/organom w
              zakresie i na zasadach określonych przepisami prawa. Wykaz imienny
              osób wyznaczonych do Komitetu wraz z informacją o tym, jakie
              podmioty reprezentują, jest publikowany na stronie internetowej
              IZ/Portalu KM FEdP. Ponadto, w zakresie stanowiącym informację
              publiczną dane będą ujawniane każdemu zainteresowanemu taką
              informacją.
            </Typography>
            <Typography point-attr="6." component="li">
              Pani/Pana dane kontaktowe (nazwiska i imiona, reprezentowany w
              Komitecie podmiot, adres e-mail), na podstawie Regulaminu Komitetu
              i zapisów Wytycznych Ministra Funduszy i Polityki Regionalnej
              dotyczących komitetów monitorujących na lata 2021-2027, podlegają
              udostępnieniu osobom ze składu Komitetu na Portalu KM FEdP w
              zakresie realizacji zadań związanych z pracą Komitetu.
            </Typography>
            <Typography point-attr="7." component="li">
              Pani/Pana dane osobowe będą przechowywane przez okres realizacji
              programu Fundusze Europejskie dla Podlaskiego 2021-2027 oraz okres
              wynikający z przepisów prawa dot. archiwizacji.
            </Typography>
            <Typography point-attr="8." component="li">
              Przysługuje Pani/Panu prawo do żądania dostępu do swoich danych
              osobowych oraz otrzymania ich kopii, a także ich sprostowania tj.
              żądania od Administratora niezwłocznego sprostowania danych
              osobowych, które są nieprawidłowe oraz żądania uzupełnienia
              niekompletnych danych osobowych oraz prawo do sprzeciwu wobec
              przetwarzania danych osobowych na podstawie art. 21 ust. 1 RODO.
              Przysługuje Pani/Panu prawo żądania ograniczenia przetwarzania
              danych osobowych z zastrzeżeniem przypadków wymienionych w art. 18
              ust. 2 RODO.
            </Typography>
            <Typography point-attr="9." component="li">
              Nie przysługuje Pani/Panu prawo żądania od Administratora:
              niezwłocznego usunięcia danych osobowych, przenoszenia danych
              osobowych, gdyż podstawą prawną przetwarzania przekazanych danych
              osobowych jest realizacja obowiązku prawnego ciążącego na
              Administratorze.{" "}
            </Typography>
            <Typography point-attr="10." component="li">
              Przysługuje Pani/Panu prawo wniesienia skargi na niezgodne z
              prawem przetwarzanie Pani/Pana danych osobowych przez
              Administratora do organu nadzorczego Prezesa Urzędu Ochrony Danych
              Osobowych (uodo.gov.pl) z siedzibą w Warszawie przy ul. Stawki 2.{" "}
            </Typography>
            <Typography point-attr="11." component="li">
              Pani/Pana dane osobowe nie będą wykorzystywane do
              zautomatyzowanego podejmowania decyzji ani profilowania, o którym
              mowa w art. 22 RODO. Pani/Pana dane nie będą przekazywane do
              państw trzecich.{" "}
            </Typography>
          </>
        ) : (
          <>
            <Typography point-attr="4." component="li">
              Podanie danych osobowych jest wymogiem ustawowym pozwalającym na
              realizację ww. celów, konsekwencją niepodania danych będzie brak
              możliwości udziału w pracach KM RPOWP.
            </Typography>
            <Typography point-attr="5." component="li">
              Pani/Pana dane osobowe będą ujawniane, z zachowaniem odpowiednich
              standardów bezpieczeństwa, osobom ze składu Komitetu zgodnie z
              postanowieniami określonymi w Regulaminie Komitetu, osobom
              upoważnionym przez Administratora, podmiotom prowadzącym
              działalność bankową, operatorowi pocztowemu lub kurierowi oraz
              podmiotom realizującym archiwizację, obsługę informatyczną i
              teleinformatyczną.
            </Typography>
            <Typography point-attr="6." component="li">
              Pani/Pana dane osobowe będą przechowywane przez okres realizacji
              Regionalnego Programu Operacyjnego Województwa Podlaskiego na lata
              2014-2020 oraz okres wynikający z przepisów prawa dot.
              archiwizacji.
            </Typography>
            <Typography point-attr="7." component="li">
              Przysługuje Pani/Panu, w zależności od charakteru przetwarzania,
              prawo dostępu do treści swoich danych osobowych oraz prawo żądania
              ich sprostowania, usunięcia lub ograniczenia przetwarzania, prawo
              do sprzeciwu, prawo do przenoszenia danych, a także prawo
              wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony
              Danych Osobowych.
            </Typography>
            <Typography point-attr="8." component="li">
              Pani/Pana dane osobowe nie będą wykorzystywane do
              zautomatyzowanego podejmowania decyzji ani profilowania, o którym
              mowa w art.
            </Typography>
          </>
        )}
      </ol>
      <Typography paragraph></Typography>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

export default connect(mapStateToProps, null)(InformationClause);
